(function () {
  function initStickyAtc(root) {
    var sectionId = root.dataset.section;
    var stickyBar = document.getElementById('StickyAtc-' + sectionId);
    var targetButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!stickyBar || !targetButton) return;

    var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
    var stickyPrice = stickyBar.querySelector('[data-sticky-atc-price]');
    var mainPrice = document.getElementById('price-' + sectionId);

    function syncButton() {
      if (!stickyButton) return;
      stickyButton.disabled = targetButton.disabled;
      var label = targetButton.querySelector('span');
      if (label && label.textContent && label.textContent.trim()) {
        stickyButton.textContent = label.textContent.trim();
      }
    }
    syncButton();
    try {
      new MutationObserver(syncButton).observe(targetButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    } catch (e) {}

    function syncPrice() {
      if (!mainPrice || !stickyPrice) return;
      var priceItem = mainPrice.querySelector('.price-item--regular, .price-item');
      if (priceItem && priceItem.textContent) {
        stickyPrice.textContent = priceItem.textContent.trim();
      }
    }
    syncPrice();
    if (mainPrice) {
      try {
        new MutationObserver(syncPrice).observe(mainPrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      } catch (e) {}
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        targetButton.click();
      });
    }

    var anchor = document.getElementById('ProductInfo-' + sectionId);
    if ('IntersectionObserver' in window && anchor) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
              stickyBar.classList.add('is-visible');
            } else {
              stickyBar.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(anchor);
    }
  }

  function initVariantImageSwitch(root) {
    var sectionId = root.dataset.section;
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
      var mediaId = input.getAttribute('data-media-id');
      if (!mediaId) return;
      try {
        gallery.setActiveMedia(mediaId, false);
      } catch (e) {}
    });
  }

  function init() {
    document.querySelectorAll('[data-product-extra-root]').forEach(function (root) {
      initStickyAtc(root);
      initVariantImageSwitch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
